function formatDate(timestamp= null) {
  const timeZone = new Date().getTimezoneOffset()
  if(timestamp){
    return new Date(timestamp - timeZone * 60 * 1000).toISOString().split(".")[0] + "Z";
  }
  return new Date(new Date().getTime() - timeZone * 60 * 1000).toISOString().split(".")[0] + "Z";
}

//toma la fecha dada de la funcion formatDate y la formatea
function formatDateTime(isoDate) {
  const date = new Date(isoDate);

  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function formatLocalDateTime(isoDate) {
  const date = new Date(isoDate);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function getTicketCount(shopCode) {
  const count = localStorage.getItem(`ticket_counter_${shopCode}`);
  return count ? parseInt(count) : 0;
}

function getAndroidIdFromLocalStorage(shopCode) {
  return localStorage.getItem(`androidId_${shopCode}`);
}
//   android "864161f09c812d8a"
function checkAndroidIsDefined(shopCode) {
  if(!shopCode) return false
  const androidId = getAndroidIdFromLocalStorage(shopCode);
  if (!androidId) {
    setTimeout(() => {
      /* eslint-disable */
      const modalElement = document.getElementById("modalUnauthorized");
      if (modalElement) {
        const modalInstance = M.Modal.init(modalElement, {
          dismissible: false, // No permite cerrar el modal
        });
        modalInstance.open();
      }
      /* eslint-enable */
    }, 800);
    return false
  }
  return true;
}

function incrementTicketCount(shopCode) {
  let currentValue = getTicketCount(shopCode);
  currentValue += 1;
  localStorage.setItem(`ticket_counter_${shopCode}`, currentValue.toString());
  return currentValue;
}

function isOlderThan(createdAt, days) {
  const now = Date.now();
  const daysInMilliseconds = days * 24 * 60 * 60 * 1000;
  const difference = now - createdAt;

  return difference > daysInMilliseconds;
}

function formattedToUserTimeZone(timestamp) {
  const raw = timestamp; 
  const [datePart, timePart] = raw.split('T');
  if (!datePart || !timePart) return raw;

  const [year, month, day] = datePart.split('-');
  const [hours, minutes, seconds] = timePart.split(':');

  const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`);

  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  

  const options = {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour12: false
  }

  const parts = new Intl.DateTimeFormat('es-ES', options).formatToParts(date);

  const get = (type) => parts.find(p => p.type === type)?.value;

  const formattedDate = `${get('day')}-${get('month')}-${get('year')}`;
  const formattedTime = `${get('hour')}:${get('minute')}:${get('second')}`;

  return `${formattedDate} ${formattedTime}`;
}

module.exports = {
  formatDate,
  formatDateTime,
  formatLocalDateTime,
  incrementTicketCount,
  getAndroidIdFromLocalStorage,
  isOlderThan,
  checkAndroidIsDefined,
  formattedToUserTimeZone
};
